/**
 * GB API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { CapiCodeId } from './capiCodeId';
import { TeilDatumSearchRequestMeta } from './teilDatumSearchRequestMeta';
import { HistorySearchOptionsMeta } from './historySearchOptionsMeta';
import { ElasticSearchOptions } from './elasticSearchOptions';


export interface PersonGbSearchErweitertRequestMeta { 
    sortDirection?: PersonGbSearchErweitertRequestMeta.SortDirectionEnum;
    mSortDirection?: FieldMetaData;
    ort?: string;
    mOrt?: FieldMetaData;
    isSearchGlaeubigerSchuldnerEnabled?: boolean;
    mIsSearchGlaeubigerSchuldnerEnabled?: FieldMetaData;
    ledigname?: string;
    mLedigname?: FieldMetaData;
    glaeubigerrolle?: PersonGbSearchErweitertRequestMeta.GlaeubigerrolleEnum;
    mGlaeubigerrolle?: FieldMetaData;
    uid?: string;
    mUid?: FieldMetaData;
    rolleSchuldner?: boolean;
    mRolleSchuldner?: FieldMetaData;
    personStammVersionArt?: PersonGbSearchErweitertRequestMeta.PersonStammVersionArtEnum;
    mPersonStammVersionArt?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    rolleUebrigeBerechtigeGrundlast?: boolean;
    mRolleUebrigeBerechtigeGrundlast?: FieldMetaData;
    plz?: string;
    mPlz?: FieldMetaData;
    isSearchEigentuemerEnabled?: boolean;
    mIsSearchEigentuemerEnabled?: FieldMetaData;
    mGlaeubigerrolleList?: Array<PersonGbSearchErweitertRequestMeta.MGlaeubigerrolleListEnum>;
    mMGlaeubigerrolleList?: FieldMetaData;
    rolle?: PersonGbSearchErweitertRequestMeta.RolleEnum;
    mRolle?: FieldMetaData;
    rolleGlaeubiger?: boolean;
    mRolleGlaeubiger?: FieldMetaData;
    geburtsdatum?: TeilDatumSearchRequestMeta;
    mGeburtsdatum?: FieldMetaData;
    rolleUebrigeBerechtigeDienstbarkeit?: boolean;
    mRolleUebrigeBerechtigeDienstbarkeit?: FieldMetaData;
    elasticSearchOptions?: ElasticSearchOptions;
    mElasticSearchOptions?: FieldMetaData;
    codeGlaeubiger?: CapiCodeId;
    mCodeGlaeubiger?: FieldMetaData;
    strasse?: string;
    mStrasse?: FieldMetaData;
    mPersonStammVersionArtList?: Array<PersonGbSearchErweitertRequestMeta.MPersonStammVersionArtListEnum>;
    mMPersonStammVersionArtList?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
    rolleUebrigeBerechtigeVormerkung?: boolean;
    mRolleUebrigeBerechtigeVormerkung?: FieldMetaData;
    isSearchUebrigeBerechtigteEnabled?: boolean;
    mIsSearchUebrigeBerechtigteEnabled?: FieldMetaData;
    hausnummer?: string;
    mHausnummer?: FieldMetaData;
    codeSchuldner?: CapiCodeId;
    mCodeSchuldner?: FieldMetaData;
    ahvVersichertennummer?: string;
    mAhvVersichertennummer?: FieldMetaData;
    rolleUebrigeBerechtigeAnmerkung?: boolean;
    mRolleUebrigeBerechtigeAnmerkung?: FieldMetaData;
    personStammSort?: PersonGbSearchErweitertRequestMeta.PersonStammSortEnum;
    mPersonStammSort?: FieldMetaData;
    historySearchOptions?: HistorySearchOptionsMeta;
    mHistorySearchOptions?: FieldMetaData;
    rolleEigentuemer?: boolean;
    mRolleEigentuemer?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    sitz?: string;
    mSitz?: FieldMetaData;
}
export namespace PersonGbSearchErweitertRequestMeta {
    export type SortDirectionEnum = 'ASC' | 'DESC';
    export const SortDirectionEnum = {
        ASC: 'ASC' as SortDirectionEnum,
        DESC: 'DESC' as SortDirectionEnum
    };
    export type GlaeubigerrolleEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const GlaeubigerrolleEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as GlaeubigerrolleEnum,
        NUTZNIESSER: 'NUTZNIESSER' as GlaeubigerrolleEnum,
        ANDEREROLLE: 'ANDEREROLLE' as GlaeubigerrolleEnum
    };
    export type PersonStammVersionArtEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const PersonStammVersionArtEnum = {
        NATUERLICHE_PERSON: 'NATUERLICHE_PERSON' as PersonStammVersionArtEnum,
        SCHWEIZERISCHE_JURISTISCHE_PERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as PersonStammVersionArtEnum,
        OEFFENTLICHE_KOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as PersonStammVersionArtEnum,
        AUSLAENDISCHE_RECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as PersonStammVersionArtEnum
    };
    export type MGlaeubigerrolleListEnum = 'GRUNDPFANDGLAEUBIGER' | 'FAUSTPFANDGLAEUBIGER' | 'NUTZNIESSER' | 'ANDEREROLLE';
    export const MGlaeubigerrolleListEnum = {
        GRUNDPFANDGLAEUBIGER: 'GRUNDPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        FAUSTPFANDGLAEUBIGER: 'FAUSTPFANDGLAEUBIGER' as MGlaeubigerrolleListEnum,
        NUTZNIESSER: 'NUTZNIESSER' as MGlaeubigerrolleListEnum,
        ANDEREROLLE: 'ANDEREROLLE' as MGlaeubigerrolleListEnum
    };
    export type RolleEnum = 'EIGENTUEMER' | 'UEBRIGE_BERECHTIGTE' | 'GLAEUBIGER_SCHULDNER' | 'ALLE';
    export const RolleEnum = {
        EIGENTUEMER: 'EIGENTUEMER' as RolleEnum,
        UEBRIGE_BERECHTIGTE: 'UEBRIGE_BERECHTIGTE' as RolleEnum,
        GLAEUBIGER_SCHULDNER: 'GLAEUBIGER_SCHULDNER' as RolleEnum,
        ALLE: 'ALLE' as RolleEnum
    };
    export type MPersonStammVersionArtListEnum = 'NATUERLICHE_PERSON' | 'SCHWEIZERISCHE_JURISTISCHE_PERSON' | 'OEFFENTLICHE_KOERPERSCHAFT' | 'AUSLAENDISCHE_RECHTSFORM';
    export const MPersonStammVersionArtListEnum = {
        NATUERLICHE_PERSON: 'NATUERLICHE_PERSON' as MPersonStammVersionArtListEnum,
        SCHWEIZERISCHE_JURISTISCHE_PERSON: 'SCHWEIZERISCHE_JURISTISCHE_PERSON' as MPersonStammVersionArtListEnum,
        OEFFENTLICHE_KOERPERSCHAFT: 'OEFFENTLICHE_KOERPERSCHAFT' as MPersonStammVersionArtListEnum,
        AUSLAENDISCHE_RECHTSFORM: 'AUSLAENDISCHE_RECHTSFORM' as MPersonStammVersionArtListEnum
    };
    export type PersonStammSortEnum = 'BEZEICHNUNG' | 'ART';
    export const PersonStammSortEnum = {
        BEZEICHNUNG: 'BEZEICHNUNG' as PersonStammSortEnum,
        ART: 'ART' as PersonStammSortEnum
    };
}


